import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
import { Props } from './type'
export const PersonIcon = (props: Props) => (
  <Svg viewBox='0 0 25 25' fill='none' {...props}>
    <Path
      d='M12.5003 6.25008C13.6462 6.25008 14.5837 7.18758 14.5837 8.33342C14.5837 9.47925 13.6462 10.4167 12.5003 10.4167C11.3545 10.4167 10.417 9.47925 10.417 8.33342C10.417 7.18758 11.3545 6.25008 12.5003 6.25008ZM12.5003 16.6667C15.3128 16.6667 18.542 18.0105 18.7503 18.7501H6.25033C6.48991 18.0001 9.69824 16.6667 12.5003 16.6667ZM12.5003 4.16675C10.1982 4.16675 8.33366 6.03133 8.33366 8.33342C8.33366 10.6355 10.1982 12.5001 12.5003 12.5001C14.8024 12.5001 16.667 10.6355 16.667 8.33342C16.667 6.03133 14.8024 4.16675 12.5003 4.16675ZM12.5003 14.5834C9.71908 14.5834 4.16699 15.9792 4.16699 18.7501V20.8334H20.8337V18.7501C20.8337 15.9792 15.2816 14.5834 12.5003 14.5834Z'
      fill='#FE5000'
    />
  </Svg>
)
